import {namedEvents} from '../utils/edap';

function triggerEdapEvent(trackingContext, linkLocation, eventName) {
    const field = {
        actionlocation: linkLocation,
    };
    const event = eventName ? eventName : namedEvents.HEADER_LINK_CLICK;
    trackingContext.trigger(event, field);
}

const edapTrigger = (name, data, options) => {
    window.edap.push((edap) =>
        edap.trigger(name, data, options)
    );
};

export {triggerEdapEvent, edapTrigger};
